// @flow
import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import DocumentTitle from 'react-document-title';
import _ from 'lodash';
import classnames from 'classnames';

type Props = {
  cohorts: Array<any>,
  lastOffset: ?string,
  getCohorts: Function,
};

const CohortTable = ({ headers, cohorts }) => (
  <table className="table is-striped">
    <TableHeader columnNames={headers} />
    <TableBody data={cohorts} />
  </table>
);

CohortTable.propTypes = {
  headers: PropTypes.arrayOf(PropTypes.string).isRequired,
  cohorts: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const TableHeader = ({ columnNames }) => (
  <thead>
    <tr>
      {_.map(columnNames, name => (
        <th key={name}>{name}</th>
      ))}
    </tr>
  </thead>
);

TableHeader.propTypes = {
  columnNames: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const TableBody = ({ data }) => (
  <tbody>
    {_.map(data, (cohort, idx) => (
      <tr key={idx}>
        <th>{idx + 1}</th>
        <td>
          <Link to={`/cohorts/${cohort.cohortID}`}>
            {cohort.cohortID}
          </Link>
        </td>
        <td>{cohort.name || cohort.cohortID}</td>
        <td>{cohort.ownerID}</td>
        <td>{new Date(cohort.createdAt).toLocaleString()}</td>
      </tr>
    ))}
  </tbody>
);

TableBody.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default class CohortDashboard extends Component {

  constructor(props: Props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    this.fetchCohorts('', true);
  }

  fetchCohorts = (lastOffset: string, initial: boolean) => {
    this.props.getCohorts(10, lastOffset, initial);
  }

  render() {
    return (
      <DocumentTitle title="Marionette">
        <section className="section">
          <div className="container">
            <CohortTable headers={['No.', 'ID', 'NAME', 'OWNER ID', 'Creation Time']} cohorts={this.props.cohorts} />
            <a
              onClick={() => this.fetchCohorts(this.props.lastOffset, false)}
              className={classnames('button is-primary', {
                'is-hidden': !this.props.lastOffset,
              })}
            >Load more</a>
          </div>
        </section>
      </DocumentTitle>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/views/dashboard/cohort/CohortDashboard.jsx
 **/